import {
  EXPERT_DATA_LOADED,
  EXPERT_DATA_UNLOAD,
  EXPERT_NOT_FOUND,
  UPDATE_EXPERT_DATA,
} from './profilePageActionsTypes';
import { ARENA_REPLY_TO_REVIEW_API } from '../../utils/constants';
import isServer from '../../utils/isServer';
import { host } from '../../fromWindow';

function expertDataLoaded(expertData) {
  return { type: EXPERT_DATA_LOADED, expertData };
}
function expertDataUnload() {
  return { type: EXPERT_DATA_UNLOAD };
}
function expertDataNotFound() {
  return { type: EXPERT_NOT_FOUND };
}
function updateExpertData(expertData) {
  return { type: UPDATE_EXPERT_DATA, expertData };
}

const setExpert = expert => expertDataLoaded(expert);

const loadExpertData = (userName, staticContext = null) => async (
  dispatch,
  getState,
  { httpClient },
) => {
  const expertDataResponse = await httpClient.get(
    `https://${host}/_api/experts-arena/expert-data/${userName}`,
  );
  const expertData = expertDataResponse.data;
  if (expertData.expertNotFound) {
    if (isServer && staticContext) {
      staticContext.status = 404;
      staticContext.message = 'expert-not-found';
    }
    return dispatch(expertDataNotFound());
  } else if (expertData.hasError) {
    return dispatch(expertDataNotFound());
  } else {
    return dispatch(expertDataLoaded(expertData));
  }
};

const unloadExpertData = () => async dispatch => {
  return dispatch(expertDataUnload());
};

const addReplyToReview = (jobRequestId, replyBody) => async (
  dispatch,
  getState,
  { httpClient },
) => {
  const replyResponse = { statusText: 'OK', data: '' };
  httpClient
    .post(`https://${host}${ARENA_REPLY_TO_REVIEW_API}${jobRequestId}`, {
      replyBody,
    })
    .then(() => {
      const expert = getState().profile.expert;
      const review = expert.reviews.find(
        r => r.completedData.jobRequestId === jobRequestId,
      );
      review.reviewData.review.reply = {
        replyDate: new Date().toJSON(),
        replyBody,
      };
      dispatch(updateExpertData(expert));
    })
    .catch(e => {
      replyResponse.statusText = 'ERROR';
      replyResponse.data = e.message;
    });
  if (replyResponse.statusText === 'OK') {
    const expert = getState().profile.expert;
    const review = expert.reviews.find(
      r => r.completedData.jobRequestId === jobRequestId,
    );
    review.reviewData.review.reply = {
      replyDate: new Date().toJSON(),
      replyBody,
    };
    dispatch(updateExpertData(expert));
  }
  return replyResponse;
};

export default {
  loadExpertData,
  unloadExpertData,
  setExpert,
  addReplyToReview,
};
